import { CSSProperties } from 'react';

import { Components, Theme } from '@mui/material/styles';
import { colors } from 'styles/colors';

const buttonStyle: { size: { large: CSSProperties; small: CSSProperties } } = {
  size: {
    large: {
      height: '46px',
      fontWeight: 700,
      fontSize: '0.875rem',
      lineHeight: '20px',
      letterSpacing: '0.08em'
    },
    small: {
      height: '32px',
      fontWeight: 700,
      fontSize: '0.625rem',
      lineHeight: '16px',
      letterSpacing: '0.08em'
    }
  }
};

export const muiButtonOverride: Components<Omit<Theme, 'components'>>['MuiButton'] = {
  defaultProps: {
    disableRipple: true,
    disableElevation: true
  },
  styleOverrides: {
    root: ({ ownerState }) => ({
      ...(ownerState.variant === 'text' &&
        ownerState.color === 'primary' && {
          color: colors.text[100],
          '&:hover': {
            color: colors.text[100]
          }
        }),
      ...(ownerState.variant === 'contained' &&
        ownerState.color === 'primary' && {
          color: colors.text[100],
          outline: `2px solid #00a969`,
          '&:active': {
            // backgroundColor: colors.highlight[70]
          },
          '&:hover': {
            backgroundColor: colors.primary[60],
            outline: `2px solid ${colors.text[100]}`
          }
        }),

      ...(ownerState.variant === 'outlined' && {
        color: colors.text[100],
        border: `1px solid ${colors.navigation[80]}`,
        '&:hover': {
          border: `1px solid ${colors.text[100]}`,
          outline: `1px solid ${colors.text[100]}`
        },
        '&:active': {
          border: `1px solid ${colors.text[100]}`
        }
      }),
      fontSize: '0.875rem',
      ...(ownerState.size === 'large' && {
        ...buttonStyle.size.large
      }),
      ...(ownerState.size === 'small' && {
        ...buttonStyle.size.small
      })
    })
  }
};
